import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { CardCorteTec, ChangeConfirmation, LoadinSpin, PageTitle, Table } from '../../components';
import { Badge, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { headTbl } from '../../data/tables';

import { checkAccess } from '../../helpers/details';
import { AuthContext } from '../../auth/AuthContext';
import { UserContext } from '../../context/user/ContextUser';
import { fetchConToken } from '../../api/fetch';

const CortesTecnicos = () => {
    const { usersState } = useContext(UserContext);
    const [id, setId] = useState('');
    const [load, setLoad] = useState(false);
    const [data, setData] = useState(null);

    useEffect(() => {
        setLoad(true);
        getData();
    }, [id]);


    const getData = async () => {
        if (!id) {
            setLoad(false);
            return;
        }

        const resp = await fetchConToken(`factura/cortetec/${id}`);
        if (resp.ok) setData(resp.data);
        setLoad(false);
    };

    const { auth } = useContext(AuthContext);
    const permisos = checkAccess('Corte de técnicos', auth.accesos);
    const navigate = useNavigate();
    if (!permisos.access) navigate(`/`);

    const [show, setShow] = useState(false);

    const [info, setInfo] = useState({});
    const showDone = () => {
        setInfo({
            data: { id },
            endpoint: `apptec/cortedone/${id}`,
            head: 'Pagar corte',
            body: `El corte del tecnico  pasara a pagado`,
        });
        setShow(true);
    };

    const ItemsC = ({ row }) => {
        let items = [];

        try {
            const parsed = JSON.parse(row.original.items);
            if (Array.isArray(parsed)) {
                items = parsed;
            } else {
                console.warn('Items no es un array:', parsed);
            }
        } catch (error) {
            console.error('Error al parsear items:', error);
        }

        if (!Array.isArray(items) || items.length === 0) {
            return <span className="text-muted">Sin datos</span>;
        }

        return (
            <div>
                {items.map((pt, i) => (
                    <Col xs={1} key={i + 'napsy'}>
                        <span className={`badge bg-light text-dark ms-1 fs-6`}>
                            {pt.type} ${pt.monto}
                        </span>
                    </Col>
                ))}
            </div>
        );
    };

    const columns = [
        {
            Header: 'Cliente',
            accessor: 'nombre',
            sort: true,
        },
        {
            Header: 'Monto',
            accessor: 'monto',
            sort: true,
            Cell: ({ value }) => <>${value}</>,
        },
        {
            Header: 'Estado',
            accessor: 'estado',
            sort: true,
            Cell: ({ value }) => (
                <Badge bg={`${value == 0 ? 'danger' : 'SUCCESS'}`}>{value == 0 ? 'PENDIENTE' : 'PAGADO'}</Badge>
            ),
        },
        {
            Header: 'Fecha',
            accessor: 'fecha',
            sort: true,
        },
        {
            Header: 'Desglose',
            accessor: 'items',
            sort: true,
            Cell: ItemsC,
        },
        {
            Header: 'Tipo',
            accessor: 'tipo',
            sort: true,
            Cell: ({ value }) => {
                let bgColor;

                switch (value) {
                    case 'INSTALACIÓN':
                        bgColor = 'info';
                        break;
                    case 'TICKET':
                        bgColor = 'primary';
                        break;
                    default:
                        bgColor = 'dark';
                }

                return <Badge bg={bgColor}>{value}</Badge>;
            },
        },
    ];
    const sizePerPageList = headTbl(data?.corte.length);
    if (load) return <LoadinSpin />;
    console.log('********:', usersState.agentes);
    return (
        <div>
            <PageTitle
                breadCrumbItems={[
                    { label: 'Finanzas', path: '/finanzas' },
                    { label: 'Cortes de tecnicos', path: '/admin/cortes', active: true },
                ]}
                title={'Cortes de tecnicos'}
            />
            <Card>
                <Card.Body>
                    <div className="d-flex justify-content-center">
                        <Col sm={5}>
                            <Form.Group className="mb-3" controlId="validationCustom19">
                                <Form.Label>Buscar corte de Agente</Form.Label>
                                <Form.Select value={id} name="tipo" required onChange={(e) => setId(e.target.value)}>
                                    <option value="">--SELECCIONAR AGENTE--</option>
                                    {usersState.agentes
                                        .filter((agente) => agente.campo === true) // <- Aquí filtras solo los "done"
                                        .map((agente) => (
                                            <option key={agente.id_agent} value={agente.id_agent}>
                                                {agente.name}
                                            </option>
                                        ))}
                                </Form.Select>
                                {/* <Select
                                    className="react-select"
                                    classNamePrefix="react-select"
                                    placeholder="Agente"
                                    maxMenuHeight={550}
                                    value={agentes.find((ag) => ag.value === id)} // Encuentra el objeto correspondiente al valor
                                    onChange={(selectedOption) => setId(selectedOption.value)} // Guarda el valor seleccionado
                                    options={agentes.map((ag) => ({ value: ag.id_agent, label: ag.name }))} // Asegúrate de que 'agentes' tenga 'id' y 'nombre'
                                /> */}
                            </Form.Group>
                        </Col>
                        {id && (
                            <Col sm="2" className="mt-3">
                                <Button size="lg" variant="primary" onClick={() => showDone()}>
                                    Entregado <i className="mdi mdi-cash-check   "></i>
                                </Button>
                            </Col>
                        )}
                    </div>

                    <Col>
                        {data ? (
                            <>
                                <CardCorteTec data={data} />{' '}
                                <Table
                                    columns={columns}
                                    data={data.corte}
                                    pageSize={25}
                                    sizePerPageList={sizePerPageList}
                                    isSortable={true}
                                    pagination={true}
                                    isSearchable={true}
                                    searchBoxClass="mb-2"
                                />
                            </>
                        ) : null}
                    </Col>
                </Card.Body>
            </Card>
            <ChangeConfirmation show={show} onClose={() => setShow(false)} info={info} callBk={getData} method="GET" />
        </div>
    );
};

export default CortesTecnicos;
